import { render } from "./BaseTablePagination.vue?vue&type=template&id=3ed89382&ts=true"
import script from "./BaseTablePagination.vue?vue&type=script&lang=ts"
export * from "./BaseTablePagination.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__